import React, { useEffect, useState } from "react";
import { Form, Col, Row, Input, Button, Checkbox, Tag, Select, DatePicker, InputNumber, Radio, Typography } from "antd";
import config from '../../config/form.json'
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { orgmode, productSelection, editactive, showloader, inwardPartner, newPartnerList } from "../../store/gloabalState";
import TextArea from "antd/lib/input/TextArea";
import dayjs from 'dayjs'
import { CountryCode, alphanumericRegex, cinRegex, countryOfIncorporation, emailRegex, hsnNumberRegex, onlyNumericDigitsRegex, onlyNumericDigitsWithDecimalRegex, phoneRegex, tanRegex, websiteRegex, } from "../../config/globalVar";
import SectionHeading from "./section-headings";
import { handleCkycFinish } from "../../utils/onboarding/ckyc/handle-ckyc-finish";
import useNotify from "../../utils/useNotify";
import { putAddress, postAddress, getOrgsDetails } from "../../services/httpCalls";
import Cookies from 'js-cookie'
import { getPanDetails } from "../../utils/onboarding/ckyc/get-pan-details";
import globalVar from "../../config/globalVar";
import { showField} from "../../utils/onboarding/onboardingUtils";
import { getFinalOptions } from "../../utils/onboarding/ckyc/get-final-options";

const convertXflowPurposeCodes = (data) => {
  return data.map((item) => {
    return item.code;
  })
}

const CkycNew = ({ handleChange }) => {

  // initializing form
  const [form] = Form.useForm();

  // getting ckyc config data
  const configData = config.ckyc[0];

  // local states
  const [pan, setPan] = useState("")
  const [disablePan, setDisablePan] = useState(false)
  const [isGstNotThere, setIsGstNotThere] = useState(false)
  const [businessDetails, setBusinessDetails] = useState({
    legalName: "",
    gstNumber: "",
    cin: "",
    leiNumber: "",
    dateOfIncorporation: "",
    countryOfIncorporation: "",
    placeOfIncorporation: "",
    companyType: "",
    natureOfBussiness: "",
    premise: "",
    annualTurnover: "",
    netWorth: "",
    importExportCode: "",
    isListedCompany: "",
    tan: ""
  })
  const [flagAddress, setFlagAddress] = useState(false)
  const [sameAddress, setSameAddress] = useState(false)
  const [isOptInward, setIsOptInward] = useState(false)
  const [isOptOutward, setIsOptOutward] = useState(false)
  const [addressThere, setAddressThere] = useState(false)
  const [companyTypeState, setCompanyTypeState] = useState("")
  const [addressIds, setAddressIds] = useState({
    BUSINESS: "",
    REGISTERED: ""
  })
  const [iseefc, setIsEeffc] = useState(false)
  const [website, setWebsite] = useState("")
  const [socialWebsite, setSocialWebsite] = useState("")
  const [urlsRequired, setUrlsRequired] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(0);
  const [isXflowActive, setIsXflowActive] = useState(false);
  const [oldXflowPurposeCode, setOldXflowPurposeCode] = useState([]);


  // global states

  // values
  const mode = useRecoilValue(orgmode)
  const isEditActive = useRecoilValue(editactive)
  const partnerState = useRecoilValue(inwardPartner)
  const partnerListState = useRecoilValue(newPartnerList);

  // updated/setter
  const setShowLoader = useSetRecoilState(showloader)


  // states
  const [selectionValue, setSelectionValue] = useRecoilState(productSelection)

  // constants/binders
  const tanRegexRef = tanRegex;
  const emailRegexRef = emailRegex;
  const onlyNumericDigitsWithDecimalRegexRef = onlyNumericDigitsWithDecimalRegex;
  const websiteRegexRef = websiteRegex;
  const phoneRegexRef = phoneRegex;
  const onlyNumericDigitsRegexRef = onlyNumericDigitsRegex
  let notify = useNotify()
  const dateFormat = "YYYY-MM-DD";
  const dayjsInstance = dayjs;
  const purposeCodeInwardInstance = globalVar.purposeCodesInward;
  const purposeCodeInwardXflowInstance  = globalVar.xflowInwardPurposeCodes;
  const CountryCodeInstance = CountryCode;
  const countryOfIncorporationInstance = countryOfIncorporation;
  const alphanumericRegexRef = alphanumericRegex;
  const hsnNumberRegexRef = hsnNumberRegex;
  const cinRegexRef = cinRegex;
  const isRequired = (selectionValue === 'inward' || selectionValue === 'both') ? isGstNotThere ? false : true : true;
  const WEBSITE = "website"
  const SOCIAL_WEBSITE = "socialWebsite"
  const [merchantProductType, setMerchantProductType] = useState("")
  const handleWebsite = (e, type) => {
    if (type === WEBSITE)
      setWebsite(e.target.value)
    if (type === SOCIAL_WEBSITE)
      setSocialWebsite(e.target.value)
  }

  useEffect(() => {
    let orgId = localStorage.getItem("orgId")
    getOrgsDetails(orgId)
      .then(res => {
        if(res?.xflowAccountCreationStatus === "ACTIVATED"){
          setIsXflowActive(true);
        }
        if (res?.website) {
          setWebsite(res.website)
        }
        if (res?.socialWebsite) {
          setSocialWebsite(res.socialWebsite)
        }
        setCompanyTypeState(res?.companyType)
        setIsOptInward(res?.isOptInward)
        setIsOptOutward(res?.isOptOutward)
        if (res?.isOptInward && res?.isOptOutward) {
          setIsGstNotThere(res?.gstNumber ? false : true)
          setSelectionValue("both")
        } else if (res?.isOptInward && !res?.isOptOutward) {
          setSelectionValue("inward")
          setIsGstNotThere(res?.gstNumber ? false : true)
        } else {
          setSelectionValue("outward")
        }
        form.setFieldsValue({
          panNumber: res?.panNumber,
          legalName: res?.name,
          gstNumber: res?.gstNumber ? res?.gstNumber : "",
          cin: res.cinNumber,
          leiNumber: res.leiNumber,
          dateOfIncorporation: res.dateOfIncorporation
            ? dayjs(res?.dateOfIncorporation, dateFormat)
            : "",
          countryOfIncorporation: res.countryOfIncorporation,
          placeOfIncorporation: res.placeOfIncorporation,
          premise: res.premise,
          annualTurnover: res.annualTurnover,
          netWorth: res.netWorth,
          natureOfBussiness: res.natureOfBusiness,
          listedCompany: res.listedCompany,
          companyType: res.companyType,
          importExportCode: res.importExportCode,
          tan: res.tanNumber,
          website: res?.website,
          socialWebsite: res?.socialWebsite,
          productDescription: res?.productDescription,
          descriptionForOutward: res?.descriptionForOutward,
          descriptionForInward: res?.descriptionForInward,
          comapnyEmail: res.orgEmail,
          selectedInwardBankAccountType:
            res?.selectedInwardBankAccountType === "EEFC" ? true : false,
          doingBusinessAs: res?.doingBusinessAs,
          // payglocal new fields
          hsnNumber: res.hsnNumber,
          monthlyPaymentVolume: res.monthlyPaymentVolume,
          howCustomerInteractWithBusiness: res.howCustomerInteractWithBusiness,
          doingBusinessAs: res.doingBusinessAs,
          merchantProductType: res.merchantProductType,
          phoneNumber: res.phoneNumber,
          averageTicketSize: res.averageTicketSize,
          purposeCode: res?.purposeCode,
          additionalUrl: res?.additionalUrl,
        })
        if(res?.xflowPurposeCodeList?.length){
            let pc = convertXflowPurposeCodes(res?.xflowPurposeCodeList)
            form.setFieldValue('xflowPurposeCode', pc);
            setOldXflowPurposeCode(pc);
        }
        setMerchantProductType(partnerState?.includes("payglocal") ? res?.merchantProductType : "")
        setIsEeffc(res?.selectedInwardBankAccountType === "EEFC" ? true : false)
        setPan(res?.panNumber)
        let addresslineforbusiness = ""
        let addresslineforregistered = ""
        if (res?.addresses?.length > 0) {
          res?.addresses?.forEach(item => {
            if (item.type === "BUSINESS") {
              form.setFieldsValue({
                //business address detail
                bussinessAddress_addressLineOne: item.addressLineOne,
                bussinessAddress_addressLineTwo: item.addressLineTwo,
                bussinessAddress_city: item.city,
                bussinessAddress_country: item.country,
                bussinessAddress_pinCode: item.pinCode,
                bussinessAddress_state: item.state
              })
              let addressIds_ = addressIds
              addressIds_.BUSINESS = item.id
              setAddressIds(addressIds_)
              addresslineforbusiness = item?.addressLineOne
              // if (item.addressLineOne || item.addressLineTwo) {
              //   setSameAddress(true)
              // }
            } else {
              form.setFieldsValue({
                //registered address detail
                registeredAddress_addressLineOne: item?.addressLineOne,
                registeredAddress_addressLineTwo: item?.addressLineTwo,
                registeredAddress_city: item?.city,
                registeredAddress_country: item?.country,
                registeredAddress_pinCode: item?.pinCode,
                registeredAddress_state: item?.state
              })
              addresslineforregistered = item?.addressLineOne
              let addressIds_ = addressIds
              addressIds_.REGISTERED = item?.id
              setAddressIds(addressIds_)
            }
            setAddressThere(true)
          })
        }
        if (addresslineforbusiness === addresslineforregistered) {
          setSameAddress(true)
        } else {
          setSameAddress(false)
        }
      })
      .catch(err => console.log(err))
  }, [partnerState])

  // for removing error messages if the other field has been filled
  useEffect(() => {
    if (!socialWebsite && !website) {
      form.setFields([
        {
          name: "socialWebsite",
          errors: ['Required!']
        },
        {
          name: "website",
          errors: ['Required!']
        }
      ])
    } else {
      form.setFields([
        {
          name: "socialWebsite",
          errors: []
        },
        {
          name: "website",
          errors: []
        }
      ])
    }

  }, [socialWebsite, website, form])

  // preventing backspace for selected purpose code
  const HandleInputKeyDown = (event) => {
    if (event.key === 'Backspace') {
        return event.stopPropagation()
    }
  }

  // handling url required condition when pg is selected certain company types are selected
  useEffect(() => {
    partnerState.includes("payglocal") && (companyTypeState === "SOLE_PRORIETOR" || companyTypeState === "FREELANCER") ? setUrlsRequired(true) : setUrlsRequired(false);
  }, [partnerState, companyTypeState])

  const customTagRender = (props) => {
    const { label, value, closable, onClose } = props;
    return (
      <Tag
        key={value}
        closable={oldXflowPurposeCode?.includes(value) ? false : closable}
        onClose={(e) => {
          e.preventDefault();
          onClose();
        }}
        style={{
          display:'flex',
          alignItems:'center',
        }}
      >
        {value}
      </Tag>
    );
  };


  const getPanDetailsCall = async (pan) => {
    await getPanDetails({
      pan,
      disablePan,
      setDisablePan,
      setPan,
      form,
      setShowLoader,
      Cookies,
      dayjs,
      setIsGstNotThere,
      notify
    })
  }

  const renderField = (field, index) => {
    const { type, label, name, props, style, tooltip } = field;

    // formatting rules
    field?.rules?.forEach(item => {
      if (item?.pattern) {
        item.pattern = eval(item?.pattern);
      }
      if (item?.required) {
        item.required = eval(item?.required);
      }
      if (item?.validator) {
        item.validator = eval(item?.validator)
      }
    });

    // conditional rendering
    if (!field?.product.includes(selectionValue)) return null;

    switch (type) {
      case 'Form.Item':
        return (
          <React.Fragment key={index}>
            <Form.Item
              label={label}
              name={name}
              rules={eval(field?.rules)}
              tooltip={tooltip}
              labelCol={field?.labelCol}
              required={eval(field?.required)}
            >
              {field?.children ? renderField(field?.children, 0) : null}
            </Form.Item>
            {field?.subFields ? field?.subFields.map((child, childIndex) => renderField(child, childIndex)) : null}
          </React.Fragment>
        )
      case 'Input':
        return (
          <Input
            disabled={eval(props?.disabled)}
            readOnly={eval(props?.readOnly)}
            name={field?.name}
            onKeyUp={eval(props?.onKeyUp)}
            onChange={eval(props?.onChange)}
          />
        );
      case 'Button':
        return (
          <Button
            type={type}
            style={style}
            onClick={eval(props.onClick)}
            disabled={eval(props.disabled)}
          >
            {eval(label)}
          </Button>
        )
      case 'TextArea':
        return (
          <TextArea
            className={field.className}
            maxLength={field.maxLength}
            readOnly={eval(field.readOnly)}
            disabled={eval(props?.disabled)}
          />
        )
      case 'Checkbox':
        return (
          <Checkbox
            checked={eval(props?.checked)}
            onChange={eval(props?.onChange)}
            style={props?.style}
            disabled={eval(props?.disablePan)}
          >
            {props?.label}
          </Checkbox>
        )
      case 'Select': {
        let finalOptions = getFinalOptions(field, partnerListState)
        
        return (
          <Select
            onInputKeyDown={eval(props?.onInputKeyDown)}
            mode={field?.mode}
            tagRender={eval(props?.customTagRender)}
            options={eval(finalOptions)}
            readOnly={eval(props?.readOnly)}
            disabled={eval(props?.disabled)}
            showSearch={props?.showSearch}
            allowClear={props?.allowClear}
            default={field?.default}
            filterOption={eval(props?.filterOption)}
            onKeyUp={eval(props?.onKeyUp)}
            optionFilterProp={props?.optionFilterProp}
          />
        )
      }
      case 'DatePicker':
        return (
          <DatePicker
            format={eval(props?.format)}
            disabledDate={eval(props.disabledDate)}
          />
        );
      case 'InputNumber':
        return (
          <InputNumber
            style={style}
            type={props.type}
            controls={field?.controls}
            onKeyUp={eval(props?.onKeyUp)}
            readOnly={eval(props?.readOnly)}
          />
        )
      case 'Radio.Group':
        return (
          <Radio.Group
            defaultValue={field?.defaultValue}
            onChange={eval(field?.onChange)}
            value={eval(field?.value)}
          >
            {field?.children?.map((child, childIndex) => renderField(child, childIndex))}
          </Radio.Group>
        )
      case 'Radio':
        return (
          <Radio
            value={eval(field?.value)}
          >
            {field?.label}
          </Radio>
        )
      case 'SectionHeading':
        return (
          <SectionHeading
            style={field?.style}
            level={field?.level}
            heading={field?.heading}
            Col={field?.Col}
          />
        )
      default:
        return null;
    }
  }

  const handleValueChange = (values) => {
    if (values.panNumber) {
      setPan(values.panNumber)
    } else if (values.merchantProductType) {
      setMerchantProductType(values.merchantProductType)
    }
    localStorage.setItem("allowCkyc", "false")
  }

  const updateAddress = async (addressData, orgId, addressId) => {
    return putAddress(addressData, orgId, addressId)
      .then(res => {
        if (res) {
          notify.success("Address updated !")
          window.localStorage.setItem("allowCkyc", "true")
          setFlagAddress(false)
          return res;
        }
      })
      .catch(err => {
        if (err) {
          return err;
        }
      })
  }

  const addAddress = async (addressData, orgId) => {
    return postAddress(addressData, orgId)
      .then(res => {
        if (res) {
          notify.success("Address added !")
          window.localStorage.setItem("allowCkyc", "true")
          setFlagAddress(false)
          return res;
        }
      })
      .catch(err => {
        if (err) {
          notify.error(err?.response?.data?.errors)
          return err;
        }
      })
  }

  const handleCkycFinishCall = (values) => {
    handleCkycFinish({
      values,
      isGstNotThere,
      dateFormat,
      isOptInward,
      isEditActive,
      addressThere,
      flagAddress,
      sameAddress,
      updateAddress,
      addressIds,
      addAddress,
      Cookies,
      notify,
      handleChange,
      setShowLoader,
      selectionValue,
      form, 
      partnerState,
      companyTypeState,
      website,
      socialWebsite,
      merchantProductType,
      isOptOutward,
      isXflowActive
    })
  }

  useEffect(() => {
    setForceUpdate(prev => prev + 1);  // Increment the value to trigger re-render
  }, [merchantProductType, oldXflowPurposeCode, sameAddress]);

  return (
    <Form
      {...configData.formConfig}
      form={form}
      onFinish={(values) => handleCkycFinishCall(values)}
      onValuesChange={handleValueChange}
      className={mode === 'view' && 'readOnly'}
      key={forceUpdate}
    >
      <Row gutter={[16, 16]}>
        {configData.fields.map((field, index) => {
          // conditional render with products that are included/selected

          const isBusinessAddressSame = field?.businessAddress ? !sameAddress : true;
          const pgCompanyType = partnerState.includes("payglocal") ? 
          field?.hasOwnProperty("companyTypeRequired") ? 
          field?.companyTypeRequired?.includes(companyTypeState) 
          : true 
          : true;
          const isGstRequired = field.hasOwnProperty('isGstNotThere') ? isGstNotThere === field?.isGstNotThere : true;
          const companyTypeConditionalRender = companyTypeState === "SOLE_PRORIETOR" ? ["SOLE_PRORIETOR", "all"].includes(field?.companyType) : ["others", "all"].includes(field?.companyType);
          const companyTypeToAllowRender =  field?.hasOwnProperty("companyTypeToAllow") ? field?.companyTypeToAllow?.includes(companyTypeState) : true

          const isVisible = showField(field.productList , partnerListState)  &&  isGstRequired && companyTypeConditionalRender && isBusinessAddressSame && pgCompanyType && companyTypeToAllowRender;

          const isRefactoredRender = isVisible;

          return isRefactoredRender && (
            <Col key={index} span={field?.Col ? field?.Col : 12}>
              {renderField(field, index)}
            </Col>
          )
        })}

      </Row>
      <div className='fixed_btn_wrap'>
        <Button onClick={() => handleChange(1)}>Previous</Button>
        <Button type="primary" style={{ marginLeft: ".5rem" }} htmlType="submit" >Next</Button>
      </div>
    </Form>
  )

}

export default CkycNew;
